import PropTypes from 'prop-types';

export default function LoadingOverlay({ message, submessage }) {
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/70 backdrop-blur-sm">
      <div className="bg-white dark:bg-gray-900 rounded-3xl shadow-2xl px-8 py-6 flex flex-col items-center gap-4 text-center">
        <div className="spinner h-12 w-12" aria-hidden="true" />
        <div>
          <p className="text-base font-semibold text-gray-900 dark:text-white">{message}</p>
          {submessage && (
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">{submessage}</p>
          )}
        </div>
      </div>
    </div>
  );
}

LoadingOverlay.propTypes = {
  message: PropTypes.string.isRequired,
  submessage: PropTypes.string
};
